import { AgencyGoal } from '__generated-api__';

export interface IAgencySalesGoalReport {
  /**
   * Can be 0.
   */
  totalRevenue: number;

  /**
   * Can be 0.
   */
  lastFiscalYearRevenue: number;

  /**
   * Can be 0.
   */
  salesGoal: number;

  /**
   * Can be 0. Can be Infinity.
   */
  percentGoalAchieved: number;

  /**
   * Can be 0.
   */
  averageOrderSize: number;

  /**
   * Can be 0.
   */
  lastFiscalYearAverageOrderSize: number;

  /**
   * Can be 0. Can be Infinity.
   */
  orderSizeGrowthPercent: number;

  /**
   * Can be 0.
   */
  totalOrders: number;

  /**
   * Can be 0.
   */
  lastFiscalYearOrders: number;
}

export const getAgencySalesGoalReport = (goals: AgencyGoal[] | undefined): IAgencySalesGoalReport | null => {
  if (!goals || !goals.length) {
    return null;
  }

  const totalRevenue = goals.reduce((sum, goal) => sum + Number(goal.total_revenue), 0);
  const lastFiscalYearRevenue = goals.reduce((sum, goal) => sum + Number(goal.last_fiscal_year_revenue), 0);
  const salesGoal = goals.reduce((sum, goal) => sum + Number(goal.sales_goal), 0);
  const percentGoalAchieved = totalRevenue / salesGoal;
  const averageOrderSize = goals.reduce((sum, goal) => sum + Number(goal.average_order_size), 0) / goals.length;
  const lastFiscalYearAverageOrderSize =
    goals.reduce((sum, goal) => sum + Number(goal.last_fiscal_year_average_order_size), 0) / goals.length;
  const orderSizeGrowthPercent = (averageOrderSize - lastFiscalYearAverageOrderSize) / lastFiscalYearAverageOrderSize;
  const totalOrders = goals.reduce((sum, goal) => sum + Number(goal.total_orders), 0);
  const lastFiscalYearOrders = goals.reduce((sum, goal) => sum + Number(goal.last_fiscal_year_orders), 0);

  return {
    totalRevenue,
    lastFiscalYearRevenue,
    salesGoal,
    percentGoalAchieved,
    averageOrderSize,
    lastFiscalYearAverageOrderSize,
    orderSizeGrowthPercent,
    totalOrders,
    lastFiscalYearOrders,
  };
};
